import React from 'react';
import * as i18n from 'i18next';

function ZeroRecordHeader() {
  return <p>{i18n.t('trackers:trackingScreen:zeroRecords')}</p>;
}

export default ZeroRecordHeader;
